import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { Link } from "react-router-dom";
import "../styles/Vendors.css";

const API_BASE = "https://globisun-app.onrender.com"; // ✅ Live backend URL

export default function Vendors() {
  const { token } = useContext(AuthContext);
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const res = await fetch(`${API_BASE}/services/vendor/approved`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const data = await res.json();
        if (!res.ok) throw new Error(data.msg || "Failed to load vendors");

        // Ensure images array exists
        const processed = data.map((v) => ({
          ...v,
          images: v.images && v.images.length ? v.images : v.image ? [v.image] : [],
        }));

        setVendors(processed);
      } catch (err) {
        console.error("Vendor fetch error:", err.message);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchVendors();
  }, [token]);

  return (
    <div className="vendors-page">
      <h2>🛒 Available Vendors</h2>

      {loading && <p>⏳ Loading vendors...</p>}
      {error && <p className="error-msg">❌ {error}</p>}

      <div className="vendors-grid">
        {vendors.length === 0 && !loading && <p>No vendors available.</p>}

        {vendors.map((vendor) => (
          <div key={vendor._id} className="vendor-card">
            <div className="vendor-images">
              {vendor.images.map((img, idx) => (
                <img
                  key={idx}
                  src={`${API_BASE}${img}`}
                  alt={`${vendor.title} ${idx + 1}`}
                />
              ))}
            </div>

            <div className="vendor-info">
              <h3>{vendor.title}</h3>
              <p>{vendor.description}</p>
              <p><strong>₦{vendor.price}</strong></p>
              <p><small>Category: {vendor.category}</small></p>

              {/* Contact Vendor Button */}
              {vendor.uploader && (
                <Link to={`/chat/${vendor.uploader}`} className="contact-btn">
                  💬 Contact Vendor
                </Link>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
